import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, remove, update, add } from "@/api/system/param";
import { mapGetters } from "vuex";
import { queryTenantList } from "@/api/system/dictbiz";
export default {
  data: function data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      tenantList: [],
      tenantVal: '',
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogClickModal: false,
        column: [{
          label: "参数名称",
          prop: "paramName",
          search: true,
          span: 24,
          rules: [{
            required: true,
            message: "请输入参数名称",
            trigger: "blur"
          }]
        }, {
          label: "参数键名",
          prop: "paramKey",
          search: true,
          span: 24,
          rules: [{
            required: true,
            message: "请输入参数键名",
            trigger: "blur"
          }]
        }, {
          label: "参数键值",
          prop: "paramValue",
          type: "textarea",
          span: 24,
          minRows: 6,
          rules: [{
            required: true,
            message: "请输入参数键值",
            trigger: "blur"
          }]
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.param_add, false),
        viewBtn: this.vaildData(this.permission.param_view, false),
        delBtn: this.vaildData(this.permission.param_delete, false),
        editBtn: this.vaildData(this.permission.param_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    rowSave: function rowSave(row, done, loading) {
      var _this = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      add(data).then(function () {
        _this.onLoad(_this.page);

        _this.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    getTenantList: function getTenantList() {
      var _this2 = this;

      if (!this.tenantVal) {
        queryTenantList().then(function (res) {
          console.log(res, '--res');
          _this2.tenantList = res.data.data;
          _this2.tenantVal = _this2.tenantList[0].tenantId;
        });
      }
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this3 = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      update(data).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this4 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id, _this4.tenantVal);
      }).then(function () {
        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this5 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this5.ids);
      }).then(function () {
        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });

        _this5.$refs.crud.toggleSelection();
      });
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this6 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      this.getTenantList();
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query, {
        tenantId: this.tenantVal
      })).then(function (res) {
        var data = res.data.data;
        _this6.page.total = data.total;
        _this6.data = data.records;
        _this6.loading = false;

        _this6.selectionClear();
      });
    }
  }
};